import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Popover from "antd/lib/popover";
import Tooltip from "antd/lib/tooltip";
import Radio from "antd/lib/radio";
import Menu from "antd/lib/menu";
import sorts from "../../assets/sorts.svg";
import sortswhite from "../../assets/WhiteIcons/sorts_white.svg";
import accoArrow from "../../assets/acco_arrow-up.svg";
import accoArrowWhite from "../../assets/WhiteIcons/acco_arrow-upWhite.svg";
import {
  setWidgetMakerGraphData,
  setWidgetMakerShareGraphData,
  setWidgetMakerSharePageGraphData,
  setPageChart,
  getDeepDive,
} from "../../redux/actions/WidgetMaker/WidgetAPI";
import { setY_attribute } from "../../redux/actions/WidgetMaker/GraphConfig";
import {
  clearPaginatedData,
  FilterPillsDeepDiveResponse,
  setDefaultSortByValueInMetaData,
} from "../../redux/actions/dashboard/Tab1";
import {
  getAllFilters,
  getAllShareFilters,
  getAllTemplateFilters,
  getGlobalBrands,
  getPaneIndex,
  getWidgetGraphObject,
  useQuery,
} from "../../redux/constants";
import {
  setDeepDiveWidgetLoaders,
  setMentionPageInnerTabs,
  setMentionTabsNews,
} from "../../redux/actions/DeepDive";
import {
  setDeepDiveInfluencersObject,
  setDeepDiveMentionsObject,
  setDeepDiveNewsObject,
  setDeepDiveObject,
} from "../../redux/actions/WidgetMaker/WidgetMaker";
import { isEqual } from "date-fns";
import { setTemplateDefaultSortByValueInMetaData } from "../../redux/actions/section/section";
import IsEmpty from "../utils/IsEmpty";
import { setScreenDeepDiveData } from "../../redux/actions/commandCenter/screens/screen";
import { getDynamicIconColor } from "../../redux/constants/DynamicIconColor";
import {
  setDefaultSortByValueInMetaDataInDeepDiveDashboard,
  setSortByChangeInMetaDataInDeepDiveDashboard,
} from "../../redux/actions/DeepDiveDashboard/DeepDiveDashboard";

const SortBy = ({
  filterPills,
  metadata,
  section_index,
  widget_index,
  deepDive,
  dashboard,
  PdfDownloadStatus,
  PptGeneratingStatus,
  widget_id,
  chart_type,
  type,
  onSortByOptionChange,
  qrChannel,
}) => {
  const dispatch = useDispatch();
  let query = useQuery();
  const mentions_object = useSelector(
    (state) => state.WidgetMaker.deep_dive_mentions_object
  );
  const influencers_object = useSelector(
    (state) => state.WidgetMaker.deep_dive_influencers_object
  );
  const Section = useSelector((state) => state.Section.addSection);
  const footerValue = useSelector((state) => state.Section.footerValue);
  const authParams = useSelector((state) => state.Authentication.authParams);
  const widgetGraphConfig = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig
  );
  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const templateDetails = useSelector((state) => state.Section.templateDetails);
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const shareBrands = useSelector((state) => state.ApiCall.shareBrands);
  const shareCategory = useSelector((state) => state.ApiCall.shareCategory);
  const global_dashboard_brands = useSelector(
    (state) => state.AuthParams.global_dashboard_brands
  );
  const global_dashboard_single_brands = useSelector(
    (state) => state.AuthParams.global_dashboard_single_brands
  );
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const deepdive_object = useSelector(
    (state) => state?.WidgetMaker?.deepdive_object
  );
  const deepdive_news_object = useSelector(
    (state) => state?.WidgetMaker?.deepdive_news_object
  );
  const screen = useSelector((state) => state?.Screens?.screen);

  const [engagementValue, setEngagementValue] = useState("");
  const [selectSortBy, setSelectSortBy] = useState({
    sortBy: deepDive
      ? deepDive && widget_id === "1.1"
        ? mentions_object?.deepdive_on?.order_by?.attribute
          ? mentions_object?.deepdive_on?.order_by?.attribute
          : chart_type === "review-card"
          ? "Rating"
          : chart_type === "author-card"
          ? "FollowersCount"
          : "engagement"
        : deepDive && widget_id === "4.1"
        ? influencers_object?.deepdive_on?.order_by?.attribute
          ? influencers_object?.deepdive_on?.order_by?.attribute
          : "engagement"
        : deepDive && widget_id === "1.2"
        ? deepdive_news_object?.order_by?.attribute === "engagement"
          ? "PostCreatedDate"
          : deepdive_news_object?.order_by?.attribute
          ? deepdive_news_object?.order_by?.attribute
          : "PostCreatedDate"
        : "engagement"
      : metadata
      ? metadata?.order_by?.attribute === "firstPost" ||
        metadata?.order_by?.attribute === "mostPost"
        ? "PostCreatedDate"
        : metadata?.order_by?.attribute
      : widgetGraphConfig && widgetGraphConfig?.order_by?.attribute,
    orderBy: deepDive
      ? widget_id === "1.1"
        ? mentions_object?.deepdive_on?.order_by?.sort_order
          ? mentions_object?.deepdive_on?.order_by?.sort_order
          : "desc"
        : widget_id === "4.1"
        ? influencers_object?.deepdive_on?.order_by?.sort_order
          ? influencers_object?.deepdive_on?.order_by?.sort_order
          : "desc"
        : widget_id === "1.2"
        ? deepdive_news_object?.order_by?.sort_order
          ? deepdive_news_object?.order_by?.sort_order
          : "desc"
        : "desc"
      : metadata
      ? metadata?.order_by?.sort_order
      : widgetGraphConfig && widgetGraphConfig?.order_by?.sort_order
      ? widgetGraphConfig && widgetGraphConfig?.order_by?.sort_order
      : "desc",
  });
  let currentPath = window.location.pathname;
  let splitPath = currentPath.split("/");
  let index = getPaneIndex(panes, activeKey);

  chart_type = metadata?.is_widget_edited
    ? metadata?.chart?.chart_type
    : chart_type;

  const onSortChange = (e) => {
    let pathName = window.location.pathname?.split("/")?.[1];

    if (pathName === "edit-dashboard" || pathName === "create-dashboard") {
      setSelectSortBy(e);
      let updatedOrderBy = {
        attribute:
          metadata?.defaultSortByValue === "engagement_video_view" &&
          e?.sortBy === "engagement"
            ? "engagement_video_view"
            : e?.sortBy,
        sort_order: e?.orderBy,
        offset: 0,
      };
      // console.log("updatedOrderBy", updatedOrderBy);
      let filter_by_data;
      let postcard_pills_filter;
      if (metadata?.y_axes?.length > 0 && chart_type === "post-card") {
        filter_by_data = {
          attribute: metadata?.y_axes && metadata?.y_axes?.[0]?.attribute,
          data: filterPills,
        };
        let selectedPill;
        filterPills &&
          filterPills?.map((d) => {
            if (d?.highlight) {
              selectedPill = d?.text;
            }
          });
        postcard_pills_filter = {
          attribute: metadata?.y_axes && metadata?.y_axes?.[0]?.attribute,
          type: "varchar",
          columns: [{ name: selectedPill, type: "include" }],
        };
      }

      if (metadata) {
        let updatedSection = [...Section];
        if (section_index >= 0) {
          updatedSection[section_index].data[widget_index].order_by =
            updatedOrderBy;
          if (metadata?.y_axes?.length) {
            updatedSection[section_index].data[widget_index].filter_by_data =
              filter_by_data;
            updatedSection[section_index].data[widget_index].filter_by =
              postcard_pills_filter;
          }

          if (metadata?.data) {
            updatedSection[section_index].data[widget_index].data = null;
          }
        } else {
          updatedSection[0].data[widget_index].order_by = updatedOrderBy;
          if (metadata?.y_axes?.length) {
            updatedSection[0].data[widget_index].filter_by_data =
              filter_by_data;
            updatedSection[0].data[widget_index].filter_by =
              postcard_pills_filter;
          }
          if (metadata?.data) {
            updatedSection[0].data[widget_index].data = null;
          }
        }
        dispatch({ type: "SET_ADDSECTION", payload: updatedSection });
      }
    } else if (chart_type === "news-card" && deepDive) {
      dispatch(setMentionTabsNews(true));
      dispatch(setMentionPageInnerTabs(false));
      let widget_ids = ["1.2"];
      let arrr = {
        ...deepdive_object,
        tabName: "Mentions",
        deepdive_on: {
          ...deepdive_object.deepdive_on,
          order_by: {
            attribute: e?.sortBy
              ? e?.sortBy
              : deepdive_object?.deepdive_on?.order_by?.attribute,
            sort_order: e?.orderBy
              ? e?.orderBy
              : deepdive_object?.deepdive_on?.order_by?.sort_order,
            offset: 0,
            widget_ids: widget_ids[0],
          },
        },
      };
      dispatch(setDeepDiveObject(arrr));
      let news_object = {
        order_by: {
          attribute: e?.sortBy
            ? e?.sortBy
            : deepdive_news_object?.order_by?.attribute,
          sort_order: e?.orderBy
            ? e?.orderBy
            : deepdive_news_object?.order_by?.sort_order,
          offset: 0,
          widget_ids: widget_ids[0],
        },
      };
      dispatch(setDeepDiveNewsObject(news_object));
      let index = getPaneIndex(panes, activeKey);

      let commandCenterPath = window?.location?.pathname?.split("/")?.[1];
      if (commandCenterPath?.toLowerCase() === "CommandCenter"?.toLowerCase()) {
        arrr.screen = screen;
        // console.log("updated arrr", arrr);
        dispatch(getDeepDive(authParams, arrr, widget_ids));
      } else {
        dispatch(
          FilterPillsDeepDiveResponse(
            panes,
            index,
            authParams,
            arrr,
            widget_ids,
            query?.get("share_id")
          )
        );
      }

      if (commandCenterPath?.toLowerCase() !== "CommandCenter"?.toLowerCase()) {
        !shareTemplateData &&
          dispatch(clearPaginatedData(panes, index, "news_mentions"));
      }
      shareTemplateData &&
        dispatch({
          type: "SET_SHARE_TEMPLATE_DATA",
          payload: {
            ...shareTemplateData,
            deep_dive: {
              ...shareTemplateData?.deep_dive,
              news_mentions: {
                ...shareTemplateData?.deep_dive?.news_mentions,
                result: {
                  ...shareTemplateData?.deep_dive?.news_mentions?.result,
                  data: null,
                },
              },
            },
          },
        });
    } else if (
      !deepDive &&
      (((pathName === "dashboard" || pathName === "pin-dashboard") &&
        !panes?.[index]?.is_widget_maker_open_obj?.open_flag &&
        panes?.[index]?.isDeepDiveDashboard) ||
        shareTemplateData?.isDeepDiveDashboard ||
        screen?.isDeepDiveDashboard)
    ) {
      setSelectSortBy(e);
      let updatedOrderBy = {
        attribute:
          metadata?.defaultSortByValue === "engagement_video_view" &&
          e?.sortBy === "engagement"
            ? "engagement_video_view"
            : e?.sortBy,
        sort_order: e?.orderBy,
        offset: 0,
      };
      let filter_by_data;
      let postcard_pills_filter;
      if (metadata?.y_axes?.length > 0 && chart_type === "post-card") {
        filter_by_data = {
          attribute: metadata?.y_axes && metadata?.y_axes?.[0]?.attribute,
          data: filterPills,
        };
        let selectedPill;
        filterPills &&
          filterPills?.map((d) => {
            if (d?.highlight) {
              selectedPill = d?.text;
            }
          });
        postcard_pills_filter = {
          attribute: metadata?.y_axes && metadata?.y_axes?.[0]?.attribute,
          type: "varchar",
          columns: [{ name: selectedPill, type: "include" }],
        };
      }
      if (metadata) {
        dispatch(
          setSortByChangeInMetaDataInDeepDiveDashboard(
            section_index,
            widget_index,
            true, // TO BE CLEAR GRAPGH DATA
            "SORT_BY_CHANGE",
            {
              order_by: updatedOrderBy,
              filter_by_data: metadata?.y_axes?.length ? filter_by_data : null,
              filter_by: metadata?.y_axes?.length
                ? postcard_pills_filter
                : null,
            }
          )
        );
      }
    } else if (deepDive) {
      let index = getPaneIndex(panes, activeKey);
      let widget_ids = [widget_id];
      let influencers_att_name = "InfluencerCategory";
      let filter_by_data = {
        attribute: influencers_att_name,
        data: filterPills,
      };
      let selectedPill;
      if (chart_type === "post-card" || deepDive) {
        filterPills?.map((d) => {
          if (d.highlight) {
            selectedPill = d?.text;
          }
        });
      }

      let postcard_pills_filter = {
        attribute: influencers_att_name,
        type: "varchar",
        columns: [{ name: selectedPill, type: "include" }],
      };
      let mentions_data = {
        ...mentions_object,
        tabName: widget_id === "1.1" ? "Mentions" : "Influencers",
        deepdive_on: {
          ...mentions_object?.deepdive_on,
          order_by: {
            attribute: e?.sortBy
              ? e?.sortBy
              : deepDive &&
                widget_id === "1.1" &&
                mentions_object?.deepdive_on?.order_by?.attribute
              ? mentions_object?.deepdive_on?.order_by?.attribute
              : "engagement",
            sort_order: e?.orderBy
              ? e?.orderBy
              : deepDive &&
                widget_id === "1.1" &&
                mentions_object?.deepdive_on?.order_by?.sort_order
              ? mentions_object?.deepdive_on?.order_by?.sort_order
              : "desc",
            offset: 0,
            widget_ids: widget_ids[0],
          },
        },
        shareTemplateData: shareTemplateData,
        shareBrands: shareBrands,
      };
      let influencers_data = {
        ...influencers_object,
        tabName: widget_id === "1.1" ? "Mentions" : "Influencers",
        filter_by_data:
          chart_type === "post-card" || deepDive ? filter_by_data : null,
        filter_by:
          chart_type === "post-card" || deepDive ? postcard_pills_filter : null,
        deepdive_on: {
          ...influencers_object?.deepdive_on,
          order_by: {
            attribute: e?.sortBy
              ? e?.sortBy
              : deepDive &&
                widget_id === "4.1" &&
                influencers_object?.deepdive_on?.order_by?.attribute
              ? influencers_object?.deepdive_on?.order_by?.attribute
              : "engagement",
            sort_order: e?.orderBy
              ? e?.orderBy
              : deepDive &&
                widget_id === "4.1" &&
                influencers_object?.deepdive_on?.order_by?.sort_order
              ? influencers_object?.deepdive_on?.order_by?.sort_order
              : "desc",
            offset: 0,
            widget_ids: widget_ids[0],
          },
        },
        shareTemplateData: shareTemplateData,
        shareBrands: shareBrands,
      };
      widget_id === "1.1" &&
        dispatch(setDeepDiveMentionsObject(mentions_data, panes, index));
      widget_id === "4.1" &&
        dispatch(setDeepDiveInfluencersObject(influencers_data, panes, index));
      dispatch(setMentionPageInnerTabs(true));
      let finalObject = widget_id === "1.1" ? mentions_data : influencers_data;

      if (pathName?.toLowerCase() == "CommandCenter"?.toLowerCase()) {
        if (widget_id === "4.1") {
          let deep_dive_obj = { influencers: [] };
          dispatch({
            type: "SET_DEEP_DIVE_DATA_IN_SCREEN",
            isDeepDive: true,
            deep_dive: deep_dive_obj,
          });
        }

        finalObject.screen = screen;
        // console.log("widget_ids", widget_ids);
        dispatch(getDeepDive(authParams, finalObject, widget_ids));
      } else {
        dispatch(
          FilterPillsDeepDiveResponse(
            panes,
            index,
            authParams,
            finalObject,
            widget_ids,
            query?.get("share_id")
          )
        );
      }
      // dispatch(setMentionPageInnerTabs(true));
    } else if (shareTemplateData) {
      setSelectSortBy(e);
      let updatedOrderBy = {
        attribute:
          metadata?.defaultSortByValue === "engagement_video_view" &&
          e?.sortBy === "engagement"
            ? "engagement_video_view"
            : e?.sortBy,
        sort_order: e?.orderBy,
        offset: 0,
      };
      let filter_by_data;
      let postcard_pills_filter;
      if (metadata?.y_axes?.length > 0 && chart_type === "post-card") {
        filter_by_data = {
          attribute: metadata?.y_axes && metadata?.y_axes?.[0]?.attribute,
          data: filterPills,
        };
        let selectedPill;
        filterPills &&
          filterPills?.map((d) => {
            if (d?.highlight) {
              selectedPill = d?.text;
            }
          });
        postcard_pills_filter = {
          attribute: metadata?.y_axes && metadata?.y_axes?.[0]?.attribute,
          type: "varchar",
          columns: [{ name: selectedPill, type: "include" }],
        };
      }

      if (metadata) {
        let updateShareTemplateData = { ...shareTemplateData };
        if (section_index >= 0) {
          updateShareTemplateData.sections[section_index].widgets[
            widget_index
          ].order_by = updatedOrderBy;
          if (metadata?.y_axes?.length) {
            updateShareTemplateData.sections[section_index].widgets[
              widget_index
            ].filter_by_data = filter_by_data;
            updateShareTemplateData.sections[section_index].widgets[
              widget_index
            ].filter_by = postcard_pills_filter;
          }

          if (metadata?.graphData) {
            updateShareTemplateData.sections[section_index].widgets[
              widget_index
            ].graphData = null;
          }
          if (metadata?.persist_graphdata) {
            updateShareTemplateData.sections[section_index].widgets[
              widget_index
            ].persist_graphdata = null;
          }
          if (metadata?.deep_dive_on) {
            updateShareTemplateData.sections[section_index].widgets[
              widget_index
            ].deep_dive_on = null;
          }
        } else {
          updateShareTemplateData.section[0].widgets[widget_index].order_by =
            updatedOrderBy;
          if (metadata?.y_axes?.length) {
            updateShareTemplateData.section[0].widgets[
              widget_index
            ].filter_by_data = filter_by_data;
            updateShareTemplateData.section[0].widgets[widget_index].filter_by =
              postcard_pills_filter;
          }
          if (metadata?.graphData) {
            updateShareTemplateData.section[0].widgets[widget_index].graphData =
              null;
          }
          if (metadata?.persist_graphdata) {
            updateShareTemplateData.section[0].widgets[
              widget_index
            ].persist_graphdata = null;
          }
          if (metadata?.deep_dive_on) {
            updateShareTemplateData.section[0].widgets[
              widget_index
            ].deep_dive_on = null;
          }
        }
        dispatch({
          type: "SET_SHARE_TEMPLATE_DATA",
          payload: updateShareTemplateData,
        });
      }
    } else if (type === "authorDetailsWithPost") {
      setSelectSortBy(e);
      let updatedOrderBy = {
        attribute:
          metadata?.defaultSortByValue === "engagement_video_view" &&
          e?.sortBy === "engagement"
            ? "engagement_video_view"
            : e?.sortBy,
        sort_order: e?.orderBy,
        offset: 0,
      };
      let filter_by_data;
      let postcard_pills_filter;
      if (metadata?.y_axes?.length > 0 && chart_type === "post-card") {
        filter_by_data = {
          attribute: metadata?.y_axes && metadata?.y_axes?.[0]?.attribute,
          data: filterPills,
        };
        let selectedPill;
        filterPills &&
          filterPills?.map((d) => {
            if (d?.highlight) {
              selectedPill = d?.text;
            }
          });
        postcard_pills_filter = {
          attribute: metadata?.y_axes && metadata?.y_axes?.[0]?.attribute,
          type: "varchar",
          columns: [{ name: selectedPill, type: "include" }],
        };
      }
      let updatedMetaData = structuredClone(metadata);
      updatedMetaData.order_by = updatedOrderBy;
      updatedMetaData.filter_by_data = filter_by_data;
      updatedMetaData.filter_by = postcard_pills_filter;
      if (onSortByOptionChange && typeof onSortByOptionChange === "function") {
        onSortByOptionChange(updatedMetaData);
      }
    } else {
      setSelectSortBy(e);
      let updatedOrderBy = {
        attribute:
          metadata?.defaultSortByValue === "engagement_video_view" &&
          e?.sortBy === "engagement"
            ? "engagement_video_view"
            : e?.sortBy,
        sort_order: e?.orderBy,
        offset: 0,
      };
      let filter_by_data;
      let postcard_pills_filter;
      if (metadata?.y_axes?.length > 0 && chart_type === "post-card") {
        filter_by_data = {
          attribute: metadata?.y_axes && metadata?.y_axes?.[0]?.attribute,
          data: filterPills,
        };
        let selectedPill;
        filterPills &&
          filterPills?.map((d) => {
            if (d?.highlight) {
              selectedPill = d?.text;
            }
          });
        postcard_pills_filter = {
          attribute: metadata?.y_axes && metadata?.y_axes?.[0]?.attribute,
          type: "varchar",
          columns: [{ name: selectedPill, type: "include" }],
        };
      }

      if (metadata) {
        let updatePanes = [...panes];

        if (section_index >= 0) {
          updatePanes[index].sections[section_index].widgets[
            widget_index
          ].order_by = updatedOrderBy;
          if (metadata?.y_axes?.length) {
            updatePanes[index].sections[section_index].widgets[
              widget_index
            ].filter_by_data = filter_by_data;
            updatePanes[index].sections[section_index].widgets[
              widget_index
            ].filter_by = postcard_pills_filter;
          }

          if (metadata?.graphData) {
            updatePanes[index].sections[section_index].widgets[
              widget_index
            ].graphData = null;
          }
          if (metadata?.persist_graphdata) {
            updatePanes[index].sections[section_index].widgets[
              widget_index
            ].persist_graphdata = null;
          }
          if (metadata?.deep_dive_on) {
            updatePanes[index].sections[section_index].widgets[
              widget_index
            ].deep_dive_on = null;
          }
        } else {
          updatePanes[index].section[0].widgets[widget_index].order_by =
            updatedOrderBy;
          if (metadata?.y_axes?.length) {
            updatePanes[index].section[0].widgets[widget_index].filter_by_data =
              filter_by_data;
            updatePanes[index].section[0].widgets[widget_index].filter_by =
              postcard_pills_filter;
          }

          if (metadata?.graphData) {
            updatePanes[index].section[0].widgets[widget_index].graphData =
              null;
          }
          if (metadata?.persist_graphdata) {
            updatePanes[index].section[0].widgets[
              widget_index
            ].persist_graphdata = null;
          }
          if (metadata?.deep_dive_on) {
            updatePanes[index].section[0].widgets[widget_index].deep_dive_on =
              null;
          }
        }
        dispatch({ type: "SET_WIDGET_GRAPH_DATA", panes: updatePanes });
      }
    }
  };

  useEffect(() => {
    if (selectSortBy?.sortBy === "engagement_video_view") {
      setEngagementValue("engagement_video_view");
      let pathName = window?.location?.pathname?.split("/")?.[1];
      if (pathName === "edit-dashboard" || pathName === "create-dashboard") {
        dispatch(
          setTemplateDefaultSortByValueInMetaData(
            Section,
            footerValue?.section && section_index >= 0 ? section_index : null,
            widget_index,
            "engagement_video_view"
          )
        );
      } else if (
        !deepDive &&
        (((pathName === "dashboard" || pathName === "pin-dashboard") &&
          !panes?.[index]?.is_widget_maker_open_obj?.open_flag &&
          panes?.[index]?.isDeepDiveDashboard) ||
          shareTemplateData?.isDeepDiveDashboard ||
          screen?.isDeepDiveDashboard)
      ) {
        dispatch(
          setDefaultSortByValueInMetaDataInDeepDiveDashboard(
            section_index,
            widget_index,
            "engagement_video_view"
          )
        );
      } else if (deepDive) {
      } else if (shareTemplateData) {
        // to set default sort by value in widget
        let updatedShareTemplateData = { ...shareTemplateData };
        if (section_index >= 0 && updatedShareTemplateData?.sections) {
          updatedShareTemplateData.sections[section_index].widgets[
            widget_index
          ].defaultSortByValue = "engagement_video_view";
        } else {
          updatedShareTemplateData.section[0].widgets[
            widget_index
          ].defaultSortByValue = "engagement_video_view";
        }
        dispatch({
          type: "SET_SHARE_TEMPLATE_DATA",
          payload: updatedShareTemplateData,
        });
      } else {
        let index = getPaneIndex(panes, activeKey);
        dispatch(
          setDefaultSortByValueInMetaData(
            panes,
            index,
            section_index >= 0 ? section_index : null,
            widget_index,
            "engagement_video_view"
          )
        );
      }
    }
  }, [selectSortBy]);

  const getMenuOption = () => {
    return (
      <div className="text_regular">
        <div className="ItemGroup border-bottom">
          <div className="text_regular pl-15 pt-2 mb-1">Sort By</div>
          <Radio.Group
            onChange={(e) =>
              onSortChange({
                sortBy: e?.target?.value,
                orderBy:
                  deepDive && widget_id === "1.1"
                    ? mentions_object?.deepdive_on?.order_by?.sort_order
                      ? mentions_object?.deepdive_on?.order_by?.sort_order
                      : "desc"
                    : deepDive && widget_id === "4.1"
                    ? influencers_object?.deepdive_on?.order_by?.sort_order
                      ? influencers_object?.deepdive_on?.order_by?.sort_order
                      : "desc"
                    : deepDive && widget_id === "1.2"
                    ? deepdive_news_object?.order_by?.sort_order
                      ? deepdive_news_object?.order_by?.sort_order
                      : "desc"
                    : metadata
                    ? metadata?.order_by?.sort_order
                    : widgetGraphConfig?.order_by?.sort_order
                    ? widgetGraphConfig?.order_by?.sort_order
                    : "desc",
              })
            }
            value={
              selectSortBy?.sortBy === "engagement_video_view"
                ? "engagement"
                : selectSortBy?.sortBy
            }
            defaultValue="engagement"
            className="d-flex flex-column pl-15"
          >
            {!IsEmpty(graphConditionConfig?.["sort_options-card_widgets"]) &&
            graphConditionConfig?.["sort_options-card_widgets"]?.[chart_type]
              ?.length > 0
              ? Array.isArray(
                  graphConditionConfig?.["sort_options-card_widgets"]?.[
                    chart_type
                  ]
                ) &&
                graphConditionConfig?.["sort_options-card_widgets"]?.[
                  chart_type
                ]?.map((op) => {
                  return (
                    <Radio className="text_regular mb-1" value={op?.attribute}>
                      {op?.trace_name}
                    </Radio>
                  );
                })
              : ""}
          </Radio.Group>
        </div>
        <div className="ItemGroup pl-15">
          <div className="text_regular pt-2 mb-1">Order By</div>
          <Radio.Group
            className="d-flex flex-column"
            onChange={(e) =>
              onSortChange({
                sortBy: selectSortBy?.sortBy,
                orderBy: e?.target?.value,
              })
            }
            value={selectSortBy.orderBy}
          >
            <Radio className="text_regular mb-1" value="asc">
              Ascending
            </Radio>
            <Radio className="text_regular mb-10" value="desc">
              Descending
            </Radio>
          </Radio.Group>
        </div>
      </div>
    );
  };
  let menu =
    chart_type === "post-card" || chart_type === "prolific-user" || deepDive ? (
      <div className="text_regular">
        <div className="ItemGroup border-bottom">
          <div className="text_regular pl-15 pt-2 mb-1">Sort By</div>

          <Radio.Group
            onChange={(e) =>
              onSortChange({
                sortBy: e.target.value,
                orderBy:
                  deepDive && widget_id === "1.1"
                    ? mentions_object?.deepdive_on?.order_by?.sort_order
                      ? mentions_object?.deepdive_on?.order_by?.sort_order
                      : "desc"
                    : deepDive && widget_id === "4.1"
                    ? influencers_object?.deepdive_on?.order_by?.sort_order
                      ? influencers_object?.deepdive_on?.order_by?.sort_order
                      : "desc"
                    : metadata
                    ? metadata?.order_by?.sort_order
                    : widgetGraphConfig?.order_by?.sort_order
                    ? widgetGraphConfig?.order_by?.sort_order
                    : "desc",
              })
            }
            value={
              selectSortBy?.sortBy === "engagement_video_view"
                ? "engagement"
                : selectSortBy?.sortBy
            }
            defaultValue="engagement"
            className="d-flex flex-column pl-15"
          >
            <Radio className="text_regular mb-1" value="NumLikesCount">
              Number of Likes/Upvotes
            </Radio>
            <Radio className="text_regular mb-1" value="NumCommentsCount">
              Number of Comments
            </Radio>
            <Radio className="text_regular mb-1" value="NumShareCount">
              Number of Shares
            </Radio>
            <Radio className="text_regular mb-1" value="engagement">
              Total engagement/With views/video views
            </Radio>
            <Radio className="text_regular mb-1" value="engagement_rate">
              Engagement Rate
            </Radio>
            {chart_type === "prolific-user" && (
              <Radio className="text_regular mb-1" value="UserWiseCount">
                Interaction
              </Radio>
            )}
            <Radio className="text_regular mb-1" value="FollowersCount">
              Number of Followers
            </Radio>
            <Radio className="text_regular mb-15" value="PostCreatedDate">
              Posted Date
            </Radio>

            {/* {chart_type === "post-card" && 
        <>
        <Radio
          className="text_regular mb-1"
          value="Reach"
        >
          Reach
        </Radio>
         <Radio
         className="text_regular mb-1"
         value="Impression"
       >
         Impression
       </Radio></>} */}
          </Radio.Group>
        </div>
        <div className="ItemGroup pl-15">
          <div className="text_regular pt-2 mb-1">Order By</div>
          <Radio.Group
            className="d-flex flex-column"
            onChange={(e) =>
              onSortChange({
                sortBy: selectSortBy?.sortBy,
                orderBy: e.target.value,
              })
            }
            value={selectSortBy.orderBy}
          >
            <Radio className="text_regular mb-1" value="asc">
              Ascending
            </Radio>
            <Radio className="text_regular mb-10" value="desc">
              Descending
            </Radio>
          </Radio.Group>
        </div>
      </div>
    ) : chart_type === "review-card" ? (
      <div className="text_regular">
        <div className="ItemGroup border-bottom">
          <div className="text_regular pl-15 pt-2 mb-1">Sort By</div>

          <Radio.Group
            onChange={(e) =>
              onSortChange({
                sortBy: e.target.value,
                orderBy: metadata?.order_by?.sort_order
                  ? metadata?.order_by?.sort_order
                  : widgetGraphConfig?.order_by?.sort_order
                  ? widgetGraphConfig?.order_by?.sort_order
                  : "desc",
              })
            }
            value={selectSortBy?.sortBy}
            className="d-flex flex-column pl-15"
          >
            <Radio className="text_regular mb-1" value="Rating">
              Rating
            </Radio>
            <Radio className="text_regular mb-1" value="CreatedDate">
              Posted Date
            </Radio>
          </Radio.Group>
        </div>
        {/* <Menu.Divider /> */}
        <div className="ItemGroup pl-15">
          <div className="text_regular pt-2 mb-1">Order By</div>
          <Radio.Group
            className="d-flex flex-column"
            onChange={(e) =>
              onSortChange({
                sortBy: selectSortBy?.sortBy,
                orderBy: e.target.value,
              })
            }
            value={selectSortBy.orderBy}
          >
            <Radio className="text_regular mb-1" value="asc">
              Ascending
            </Radio>
            <Radio className="text_regular mb-1" value="desc">
              Descending
            </Radio>
          </Radio.Group>
        </div>
      </div>
    ) : (
      chart_type === "author-card" && (
        <div className="text_regular">
          <div className="ItemGroup border-bottom">
            <div className="text_regular pl-15 pt-2 mb-1">Sort By</div>

            <Radio.Group
              onChange={(e) =>
                onSortChange({
                  sortBy: e.target.value,
                  orderBy: metadata?.order_by?.sort_order
                    ? metadata?.order_by?.sort_order
                    : widgetGraphConfig?.order_by?.sort_order
                    ? widgetGraphConfig?.order_by?.sort_order
                    : "desc",
                })
              }
              value={selectSortBy?.sortBy}
              className="d-flex flex-column pl-15"
            >
              <Radio className="text_regular mb-1" value="FollowersCount">
                Followers
              </Radio>
              <Radio className="text_regular mb-1" value="FollowingCount">
                Following
              </Radio>
              {/* <Radio
                        className="text_regular mb-1"
                        value="NumShareCount"
                      >
                        Post Shares
                      </Radio> */}
            </Radio.Group>
          </div>
          {/* <Menu.Divider /> */}
          <div className="ItemGroup pl-15">
            <div className="text_regular pt-2 mb-1">Order By</div>
            <Radio.Group
              className="d-flex flex-column p-1"
              onChange={(e) =>
                onSortChange({
                  sortBy: selectSortBy?.sortBy,
                  orderBy: e.target.value,
                })
              }
              value={selectSortBy.orderBy}
            >
              <Radio className="text_regular mb-1" value="asc">
                Ascending
              </Radio>
              <Radio className="text_regular mb-1" value="desc">
                Descending
              </Radio>
            </Radio.Group>
          </div>
        </div>
      )
    );
  return (
    <div>
      {(splitPath[1] === "pin-dashboard" && !dashboard && !deepDive) ||
      (splitPath[1] === "dashboard" && !dashboard && !deepDive) ||
      splitPath[1] === "widgetMaker" ||
      splitPath[1] === "edit-widget" ? (
        <>
          <Tooltip
            overlayInnerStyle={{ width: "20rem", marginRight: "2rem" }}
            title="Card sorting is available only in dashboard"
          >
            <div className="ant-dropdown-link bg__white p-2 border border-color border-radius-4 text_regular-gray d-inline-flex align-items-center mb-15 cursor-pointer mt-15 mr-15">
              <img
                style={{ float: "right" }}
                src={authParams?.theme_type === "1" ? sortswhite : sorts}
                alt="Post card sorts"
                className="mr-1"
              />{" "}
              Sort By
              <img
                src={
                  authParams?.theme_type === "1" ? accoArrowWhite : accoArrow
                }
                className="accordionArrow p-0 ml-1"
                alt="Post card accoArrow"
              />
            </div>
          </Tooltip>
        </>
      ) : (
        (splitPath[1]?.toLowerCase() === "CommandCenter"?.toLowerCase() ||
          (splitPath[1] === "pin-dashboard" && dashboard) ||
          (splitPath[1] === "dashboard" && dashboard) ||
          (splitPath[1] === "pin-dashboard" && !dashboard && deepDive) ||
          (splitPath[1] === "dashboard" && !dashboard && deepDive) ||
          (splitPath[1] === "edit-dashboard" && dashboard) ||
          (splitPath[1] === "create-dashboard" && dashboard) ||
          splitPath[1] === "share") &&
        !PdfDownloadStatus &&
        !PptGeneratingStatus && (
          <Popover
            content={getMenuOption()}
            placement="bottomRight"
            overlayClassName={
              authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
            }
          >
            {deepDive ? (
              <div className="ant-dropdown-link bg__white p-2 border border-color border-radius-4 text_regular-gray d-inline-flex align-items-center mb-15 cursor-pointer mt-15 mr-15">
                <span className="mr-1">
                  {" "}
                  {authParams?.theme_type === "1"
                    ? getDynamicIconColor("sort_by_icon_white")
                    : getDynamicIconColor("sort_by_icon")}
                </span>
                {/* <img
                  src={authParams?.theme_type === "1" ? sortswhite : sorts}
                  alt="Post card sorts"
                  className="mr-1"
                />{" "} */}
                Sort By{" "}
                <span className="accordionArrow d-flex align-items-center ml-1">
                  {" "}
                  {authParams?.theme_type === "1"
                    ? getDynamicIconColor("accordion_arrow_white")
                    : getDynamicIconColor("accordion_arrow")}
                </span>
                {/* <img
                  src={
                    authParams?.theme_type === "1" ? accoArrowWhite : accoArrow
                  }
                  className="accordionArrow p-0 ml-1"
                  alt="Post card accoArrow"
                /> */}
              </div>
            ) : (
              <button
                className={`WidgetFilter_title pt-0 pb-0 ml-2 ${
                  shareTemplateData && "mr-2"
                }`}
                style={{
                  borderColor: "#678bff33",
                  lineHeight: "1.8rem",
                }}
              >
                <img
                  src={authParams?.theme_type === "1" ? sortswhite : sorts}
                  alt="Post card sorts"
                  className="mr-0"
                  style={{ maxWidth: "2.1rem" }}
                />
              </button>
            )}
          </Popover>
        )
      )}
    </div>
  );
};

export default React.memo(SortBy, isEqual);
